export const normalizeFontFamilyName = (fontFamilyName) => fontFamilyName
    .toLowerCase()
    .trim()
    .replace(/"/g, '')
    .replace(/\s/g, '-')
    .replace(/'/g, '');
//# sourceMappingURL=normalize-font-family-name.js.map